<script setup lang="ts">
import type { Subscription } from '@entities/subscription'

import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons'

import { BadgeSubscriptionStatus } from '@shared/ui/badges'
import { AppText } from '@shared/ui/typography'
import { AppTooltip } from '@shared/ui/tooltips'
import { AppIcon } from '@shared/ui/icons'

import { useSubscriptionStatusCell } from '../model/subscription-status-cell.hook'

defineOptions({
  name: 'SubscriptionStatusCell',
})

const props = defineProps<{
  subscription: Subscription
}>()

const {
  pausedUntilLabel,
  plannedPauseLabel,
} = useSubscriptionStatusCell({
  subscription: computed(() => props.subscription),
})
</script>

<template>
  <div class="subscription-status-cell">
    <BadgeSubscriptionStatus :status="subscription.status" />
    <AppText
      v-if="pausedUntilLabel"
      name="body2"
      color="slate-500"
    >
      {{ pausedUntilLabel }}
    </AppText>
    <AppTooltip
      v-if="plannedPauseLabel"
      :text="plannedPauseLabel"
      size="small"
      placement="top"
    >
      <span
        class="subscription-status-cell__warning"
        role="img"
        tabindex="0"
        :aria-label="plannedPauseLabel"
      >
        <AppIcon
          :icon="faTriangleExclamation"
          size="small"
          color="amber-500"
        />
      </span>
    </AppTooltip>
  </div>
</template>

<style scoped lang="scss" src="./SubscriptionStatusCell.scss" />
